import { axios, addHeader } from '@/api/index.js'

const dashboard = {
  async getPowerBIReport(placeholderId, accessToken) {
    return await axios.get('/powerbi/embedReport?placeholderId=' + placeholderId, addHeader(accessToken))
  },

  async getPowerBIReportFilters(placeholderId, accessToken) {
    return await axios.get('/powerbi/embedReportFilters?placeholderId=' + placeholderId, addHeader(accessToken))
  },
}

export default dashboard
